export default __webpack_public_path__ + "static/media/0x23e8b6a3f6891254988b84da3738d2bfe5e703b9.4147ecd1.webp";